<template>
  <div>
    <FormKit v-if="ready" :initialValues="usuario" type="form" @submit="submitHandler" v-model="usuario"
      :classes="{ outer: 'col-span-2' }">
      <div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-4">
          <FormKit type="text" name="nombre" placeholder="Carlos" label="Nombre" />
          <FormKit type="text" name="apellido" placeholder="García" label="Apellido" />
          <FormKit type="pais" name="pais" placeholder="Argentina" label="Selecciona tu país" />
          <FormKit v-if="usuario.pais !== 'Argentina'" type="text" name="provincia" placeholder="Buenos Aires"
            label="Provincia" />
          <FormKit v-else type="select" name="provincia" label="Selecciona tu provincia" :options="provinciasArgentina"
            :initialValue="usuario.provincia" :classes="{ outer: 'w-full' }" validation="required"
            :validationMessages="{ required: 'La provincia es obligatoria' }" />
          <FormKit type="text" name="ciudad" placeholder="CABA" label="Ciudad" />
          <FormKit type="text" name="codigoPostal" placeholder="123456" label="Código Postal" />
          <FormKit type="text" name="direccion" placeholder="Av. Corrientes 1660" label="Dirección" />
          <FormKit type="date" name="fechaNacimiento" label="Fecha de nacimiento" />
          <FormKit type="email" name="email" placeholder="ejemplo@empresa.com" label="Correo electrónico" />
          <FormKit type="telefono" name="telefono" label="Teléfono" placeholder="+54 9 11 1234 5678" />
          <div class="md:col-span-2">
            <FormKit type="textarea" name="bio" label="Bio" placeholder="Contanos algo sobre vos" />
          </div>
        </div>
      </div>
      <template #submit>
        <div class="flex justify-end">
          <FormKit type="submit" :classes="{
            outer: 'flex justify-end w-full',
            input: props.classButton
          }" label="Guardar" />
        </div>
      </template>
    </FormKit>
    <div v-else class="flex justify-center items-center h-32">
      <Cargando :simple="true" />
    </div>
  </div>
</template>

<script setup>
import { notify } from "notiwind";
import { actualizar, miUsuario } from '@/services/usuarios';
import { onMounted, ref } from 'vue';
import Cargando from "@/components/Cargando.vue";

const props = defineProps({
  classButton: {
    type: String,
    default: null
  },
});

const provinciasArgentina = [
  { value: 'Buenos Aires', label: 'Buenos Aires' },
  { value: 'Catamarca', label: 'Catamarca' },
  { value: 'Chaco', label: 'Chaco' },
  { value: 'Chubut', label: 'Chubut' },
  { value: 'Córdoba', label: 'Córdoba' },
  { value: 'Corrientes', label: 'Corrientes' },
  { value: 'Entre Ríos', label: 'Entre Ríos' },
  { value: 'Formosa', label: 'Formosa' },
  { value: 'Jujuy', label: 'Jujuy' },
  { value: 'La Pampa', label: 'La Pampa' },
  { value: 'La Rioja', label: 'La Rioja' },
  { value: 'Mendoza', label: 'Mendoza' },
  { value: 'Misiones', label: 'Misiones' },
  { value: 'Neuquén', label: 'Neuquén' },
  { value: 'Río Negro', label: 'Río Negro' },
  { value: 'Salta', label: 'Salta' },
  { value: 'San Juan', label: 'San Juan' },
  { value: 'San Luis', label: 'San Luis' },
  { value: 'Santa Cruz', label: 'Santa Cruz' },
  { value: 'Santa Fe', label: 'Santa Fe' },
  { value: 'Santiago del Estero', label: 'Santiago del Estero' },
  { value: 'Tierra del Fuego', label: 'Tierra del Fuego' },
  { value: 'Tucumán', label: 'Tucumán' },
];

const usuario = ref({
  nombre: '',
  apellido: '',
  email: '',
  telefono: '',
  ciudad: '',
  provincia: '',
  pais: '',
  direccion: '',
  fechaNacimiento: '',
  codigoPostal: '',
  bio: '',
});

const submitHandler = async (data) => {
  const datos = {
    nombre: data.nombre,
    apellido: data.apellido,
    pais: data.pais,
    provincia: data.provincia,
    ciudad: data.ciudad,
    direccion: data.direccion,
    codigoPostal: data.codigoPostal,
    fechaNacimiento: data.fechaNacimiento,
    email: data.email,
    telefono: data.telefono,
    bio: data.bio,
  };

  await actualizar(datos);
  notify({ group: "foo", title: "¡Listo!", type: "success", text: "Tus datos se guardaron correctamente" });

};

const ready = ref(false);

onMounted(async () => {
  try {
    const userData = await miUsuario();

    if (userData) {
      // Actualiza las propiedades del objeto usuario reactivo
      usuario.value = {
        nombre: userData.nombre || '',
        apellido: userData.apellido || '',
        email: userData.email || '',
        telefono: userData.telefono || '',
        ciudad: userData.ciudad || '',
        provincia: userData.provincia || '',
        pais: userData.pais || '',
        direccion: userData.direccion || '',
        fechaNacimiento: userData.fechaNacimiento || '',
        codigoPostal: userData.codigoPostal || '',
        bio: userData.bio || '',
      };
    }

    ready.value = true;


  } catch (error) {
    console.error('Error al cargar usuario:', error);
  }
});


</script>

<style lang="scss"></style>
